import { PET_AP_PER_CARD, PET_BASE_AP } from "@/pet/constants";
import type { PetDefinition } from "@/pet/types";
import type { HomeEconomy } from "@/home/economy";
import {
  STAT_IDS,
  type StatAllocation,
  type StatId,
} from "@/game/model/character-stats";

export function petApBudget(pet: PetDefinition): number {
  const cards = Math.max(0, Math.floor(pet.apCardsApplied ?? 0));
  return PET_BASE_AP + cards * PET_AP_PER_CARD;
}

export function petApSpent(allocation: StatAllocation): number {
  return STAT_IDS.reduce((sum, id) => sum + allocation[id], 0);
}

export function petApRemaining(pet: PetDefinition): number {
  return Math.max(0, petApBudget(pet) - petApSpent(pet.statAllocation));
}

export function allocatePetStatPoint(
  pet: PetDefinition,
  statId: StatId,
): PetDefinition | null {
  if (petApRemaining(pet) <= 0) return null;
  return {
    ...pet,
    statAllocation: { ...pet.statAllocation, [statId]: pet.statAllocation[statId] + 1 },
  };
}

export type ApplyPetApCardResult =
  | { ok: true; economy: HomeEconomy; pet: PetDefinition }
  | { ok: false; reason: string };

export function applyPetApCard(
  economy: HomeEconomy,
  pet: PetDefinition,
): ApplyPetApCardResult {
  if (economy.petApCards < 1) {
    return { ok: false, reason: "ไม่มีบัตร AP สัตว์เลี้ยงในคลัง · ซื้อที่ร้าน Cash" };
  }
  return {
    ok: true,
    economy: {
      ...economy,
      petApCards: economy.petApCards - 1,
    },
    pet: {
      ...pet,
      apCardsApplied: pet.apCardsApplied + 1,
    },
  };
}

export type ApplyPetSizeCardResult =
  | { ok: true; economy: HomeEconomy; pet: PetDefinition }
  | { ok: false; reason: string };

export function applyPetSizeCard(
  economy: HomeEconomy,
  pet: PetDefinition,
): ApplyPetSizeCardResult {
  if (economy.petSizeCards < 1) {
    return { ok: false, reason: "ไม่มีบัตรไซต์สัตว์เลี้ยงในคลัง · ซื้อที่ร้าน Cash" };
  }
  return {
    ok: true,
    economy: {
      ...economy,
      petSizeCards: economy.petSizeCards - 1,
    },
    pet: {
      ...pet,
      sizeCardsApplied: pet.sizeCardsApplied + 1,
    },
  };
}
